import { MatTableDataSourceBackendExtended } from "@comunicare/comunicare-angular-interfaces";
import { IAggregatedChargeItemsInfo, IChargeItemsInfo, IDataSourceBackendParam } from "@comunicare/comunicare-interfaces";
import { Observable, of } from "rxjs";
import { BillingService } from "./services/billing.service";

export class BillingDataSource extends MatTableDataSourceBackendExtended<IChargeItemsInfo | IAggregatedChargeItemsInfo> {
  public rawData$ = this.dataSubject.asObservable();

  constructor(private billingService: BillingService) {
    super();
  }

  public data(
    params: IDataSourceBackendParam & { patientId: string; aggregated?: boolean }
  ): Observable<IChargeItemsInfo[] | IAggregatedChargeItemsInfo[]> {
    if (!params.services || params.services.length < 1) {
      return of([]);
    }
    return this.billingService.findInvoices(params, params.patientId, params.aggregated);
  }
  protected dataCount(_param: IDataSourceBackendParam): Observable<number> {
    /*
        Use this, the day we decide to make the page implements AbstractBackendTablePage
        */
    return of(0);
  }
}
